import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="type-approval-selector"
export default class extends Controller {
  static targets = ["select", "feedback", "details"]
  
  connect() {
    // Listen for type approvals loaded event from IMEI validator
    document.addEventListener('type-approvals-loaded', this.handleTypeApprovalsLoaded.bind(this))
  }
  
  disconnect() {
    document.removeEventListener('type-approvals-loaded', this.handleTypeApprovalsLoaded.bind(this))
  }
  
  handleTypeApprovalsLoaded(event) {
    const { typeApprovals, tac } = event.detail
    
    // Clear and populate select options
    this.selectTarget.innerHTML = ''
    this.selectTarget.disabled = false
    
    if (typeApprovals.length === 0) {
      const option = document.createElement('option')
      option.value = ''
      option.textContent = 'No type approvals found for this TAC'
      this.selectTarget.appendChild(option)
      
      this.feedbackTarget.innerHTML = '<span class="text-amber-600">No approved type approvals found for this device TAC. Please contact support.</span>'
      this.feedbackTarget.className = 'mt-1 text-[12px]'
      
      // Clear details if target exists
      if (this.hasDetailsTarget) {
        this.detailsTarget.innerHTML = '<p class="text-[12px] text-gray-500 text-center">No type approvals available</p>'
      }
    } else {
      // Add default option
      const defaultOption = document.createElement('option')
      defaultOption.value = ''
      defaultOption.textContent = 'Select a type approval number'
      this.selectTarget.appendChild(defaultOption)
      
      // Add type approval options
      typeApprovals.forEach(approval => {
        const option = document.createElement('option')
        option.value = approval.type_approval_number
        option.textContent = `${approval.type_approval_number} - ${approval.brand || 'Unknown'} ${approval.model || ''}`
        option.dataset.approvalDetails = JSON.stringify(approval)
        this.selectTarget.appendChild(option)
      })
      
      this.feedbackTarget.innerHTML = `<span class="text-green-600">${typeApprovals.length} type approval(s) found for TAC ${tac}</span>`
      this.feedbackTarget.className = 'mt-1 text-[12px]'
      
      // Auto-select if only one approval
      if (typeApprovals.length === 1) {
        this.selectTarget.value = typeApprovals[0].type_approval_number
        // Only show details if the target exists
        if (this.hasDetailsTarget) {
          this.showApprovalDetails(typeApprovals[0])
        }
      }
    }
  }
  
  selectChanged(event) {
    const selectedOption = event.target.options[event.target.selectedIndex]
    
    if (selectedOption.value === '') {
      if (this.hasDetailsTarget) {
        this.detailsTarget.innerHTML = '<p class="text-[12px] text-gray-500 text-center">Select a type approval to view details</p>'
      }
      return
    }
    
    const approvalDetails = JSON.parse(selectedOption.dataset.approvalDetails)
    this.showApprovalDetails(approvalDetails)
  }
  
  showApprovalDetails(approval) {
    // Check if details target exists before trying to update it
    if (!this.hasDetailsTarget) {
      console.warn('Details target not found for type-approval-selector')
      return
    }
    
    this.detailsTarget.innerHTML = `
      <div class="space-y-2">
        <div class="flex justify-between">
          <span class="text-[12px] font-medium text-gray-600">Number:</span>
          <span class="text-[12px] text-gray-900">${approval.type_approval_number}</span>
        </div>
        <div class="flex justify-between">
          <span class="text-[12px] font-medium text-gray-600">TAC:</span>
          <span class="text-[12px] text-gray-900">${approval.tac}</span>
        </div>
        <div class="flex justify-between">
          <span class="text-[12px] font-medium text-gray-600">Brand:</span>
          <span class="text-[12px] text-gray-900">${approval.brand || 'N/A'}</span>
        </div>
        <div class="flex justify-between">
          <span class="text-[12px] font-medium text-gray-600">Model:</span>
          <span class="text-[12px] text-gray-900">${approval.model || 'N/A'}</span>
        </div>
        <div class="flex justify-between">
          <span class="text-[12px] font-medium text-gray-600">Status:</span>
          <span class="text-[12px] font-medium text-green-600">${approval.status}</span>
        </div>
      </div>
    `
  }
}